import { httpClient } from '../../http/httpClient';
export const saveVote = (id, vote, feedbackGeneric, feedbackFreeform) => {
  return httpClient.put(`chatspot/v1/chat-messages/${id}/feedback`, {
    data: {
      vote,
      feedbackGeneric,
      feedbackFreeform
    }
  });
};
export const removeVote = id => {
  return httpClient.delete(`chatspot/v1/chat-messages/${id}/feedback`);
};